/** @typedef {typeof import("./base")} BaseUtils */

// TODO Move all drawer related code to non-critical.js
if (!customElements.get("collection-filter")) {
  class CollectionFilter extends HTMLElement {
    constructor() {
      super();
      this.isDrawerOpen = false;
    }

    removeAccessibilityAttributes = () => {
      this.drawer?.removeAttribute("role");
      this.drawer?.removeAttribute("aria-modal");
      this.drawer?.toggleAttribute("inert", isMobile());
    };

    addAccessibilityAttributes = () => {
      this.drawer?.setAttribute("role", "dialog");
      this.drawer?.setAttribute("aria-modal", "true");
      this.drawer?.removeAttribute("inert");
    };

    updateAccessibilityValues = () => {
      if (isMobile() && this.isDrawerOpen) {
        this.addAccessibilityAttributes();
      } else {
        this.removeAccessibilityAttributes();
      }
    };

    openDrawer = () => {
      this.isDrawerOpen = true;
      this.drawerBackDrop.classList.remove("d-none");
      this.drawer?.style.setProperty("--transform-sm", `translateX(0)`);

      document.body.classList.add("overflow-hidden");
      this.updateAccessibilityValues();
      trapFocus(this.drawer, this.drawerFocusStartElement);
    };

    closeDrawer = () => {
      this.isDrawerOpen = false;
      this.drawerBackDrop.classList.add("d-none");
      this.drawer?.style.setProperty("--transform-sm", `translateX(100%)`);
      document.body.classList.remove("overflow-hidden");
      this.updateAccessibilityValues();
      removeTrapFocus(this.drawerOpenButton);
    };

    toggleDrawer = () => {
      if (this.isDrawerOpen) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    };

    /**
     * @param {Event & { currentTarget: HTMLFormElement }} e
     */
    handleSubmit = (e) => {
      e.preventDefault();
      this.closeDrawer();
      document.body.classList.add("blink");
      const url = new URL(window.location.href);

      //Clean current filters and other query params
      url.search = "";

      const formData = new FormData(e.currentTarget);
      for (const [key, value] of formData.entries()) {
        url.searchParams.append(key, value);
      }

      window.location.href = url.toString();
    };

    connectedCallback() {
      requestAnimationFrame(() => {
        const submitButton = this.querySelector("button[type=submit]");
        this.drawer = this.querySelector("form");
        this.drawerBackDrop = this.querySelector("[data-role=backdrop]");
        this.drawerFocusStartElement = this.drawer?.querySelector(
          "[data-role=focusStart]",
        );
        this.drawerOpenButton = this.querySelector("[data-role=drawerTrigger]");
        const toggleDrawerButtons = this.querySelectorAll(
          "[data-action=toggleDrawer]",
        );

        submitButton?.removeAttribute("disabled");
        this.drawer?.addEventListener("submit", this.handleSubmit);

        toggleDrawerButtons?.forEach((button) => {
          button.removeAttribute("disabled");
          button.classList.remove("blink");
          button.addEventListener("click", this.toggleDrawer);
        });

        mobileQuery.addEventListener("change", this.updateAccessibilityValues);
        this.updateAccessibilityValues();
      });
    }
  }
  customElements.define("collection-filter", CollectionFilter);
}
